import {Api} from "@hps/hops-sdk-js";

import Store from "App/Store.js";

/**
 * App service
 *
 * @package HOPS
 * @subpackage Services
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class AppService {

	/**
	 * Get registration details using our origin.
	 * 
	 * @return {Promise} Resolves with registration object
	 */
	static getRegistration() {
		return Api.call({url: `/api/local`}).then(res => {
			return res.data;
		});
	}


	/**
	 * Get the logo URI for our current registration.
	 * 
	 * @return {String}
	 */
	static getRegistrationLogo() {
		const org = Store.getState().org;
		return `${Api.baseURL}/uploads/railway_logos/${org?.LogoTrade || org?.Logo}`;
	}


	/**
	 * Get the favicon URI for our current registration.
	 * 
	 * @return {String}
	 */
	static getRegistrationFaviconUri() {
		return `${Api.baseURL}/uploads/local/${Store.getState().org?.Id}/favicon.png`;
	}


	/**
	 * Resolve a path with an org's uploads directory root.
	 *
	 * @param {Integer} org ID
	 * @param {String} path optional
	 * @return {String}
	 */
	static getOrgUploadsPath(org, path="") {
		return `${Api.baseURL}/uploads/local/${org}${path}`;
	}

}

export default AppService;
